module.exports = __webpack_public_path__ + "img/homeme.120acc64.png";